import { Expander } from '@app/components/various/Expander';
import { HelpTooltip } from '@app/components/various/HelpTooltip';
import { Folder, Link, Page } from '@app/components/various/Icons';
import { SectionCard } from '@app/components/various/SectionCard';
import { Skeleton } from '@app/components/various/Skeleton';
import { SkeletonLayout } from '@app/components/various/SkeletonLayout';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { FolderForm, LinkForm, PagesForm } from '.';

const PAGES_ID = 'expandablePages';
const LINK_ID = 'expandableLink';
const FOLDER_ID = 'expandableFolder';

interface Props {
  isLoading?: boolean;
}

export const AvailableNavigationItems = ({ isLoading = false }: Props) => {
  const [expandedItem, setExpandedItem] = React.useState<string | null>(PAGES_ID);
  const { t } = useTranslation(['common', 'settings']);

  const handleExpandedItemToggle = (id: string) => () => {
    setExpandedItem(currentId => (currentId === id ? null : id));
  };

  const getIsItemExpanded = (id: string) => {
    return expandedItem === id;
  };

  return (
    <SectionCard className="flex flex-1 basis-1/2 flex-col">
      <h3 className="mb-5 flex min-h-8 items-center gap-2 heading-3">{t('common:items_to_add')}</h3>
      <SkeletonLayout isLoading={isLoading} skeleton={<Skeleton type="rectangle" className="flex-1" />}>
        <div className="flex flex-col gap-5">
          <Expander
            headerPrefix={<Page className="size-4" />}
            header={t('common:page_other')}
            isExpanded={getIsItemExpanded(PAGES_ID)}
            onToggleExpanded={handleExpandedItemToggle(PAGES_ID)}
            headerLevel="h3"
          >
            <PagesForm />
          </Expander>
          <Expander
            headerPrefix={<Link className="size-4" />}
            header={t('common:link')}
            isExpanded={getIsItemExpanded(LINK_ID)}
            onToggleExpanded={handleExpandedItemToggle(LINK_ID)}
            headerLevel="h3"
          >
            <LinkForm />
          </Expander>
          <Expander
            headerPrefix={<Folder className="size-4" />}
            header={t('common:folder')}
            headerPostfix={<HelpTooltip content={t('settings:folder_info')} />}
            isExpanded={getIsItemExpanded(FOLDER_ID)}
            onToggleExpanded={handleExpandedItemToggle(FOLDER_ID)}
            headerLevel="h3"
          >
            <FolderForm />
          </Expander>
        </div>
      </SkeletonLayout>
    </SectionCard>
  );
};
